import { render, staticRenderFns } from "./AdminCompanyInfo.vue?vue&type=template&id=1b0e0e3a&scoped=true&"
import script from "./AdminCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompanyInfo.vue?vue&type=style&index=0&id=1b0e0e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e0e3a",
  null
  
)

export default component.exports